module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.1406/img/callout-blobs.svg"